import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pageLoaded } from '../../../../utils';

class SurveyActivityV3AgentScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidMount() {
        pageLoaded('Agent Details');        
    }


    render() {
        return <div>In SurveyActivityV3AgentScreen</div>
    }
}

const select = state => ({ ...state.SurveyActivityScreen, ...state.session });

export default connect(select)(SurveyActivityV3AgentScreen);